export default __webpack_public_path__ + "static/media/Convenient.54d9cb73.png";